<ng-container *ngIf="isLoading; else pageContent">
  <div class="app-spinner">
    <mat-spinner diameter="50"></mat-spinner>
  </div>
</ng-container>

<ng-template #pageContent>
  <ng-container *ngIf="jobData.length > 0; else showMessage">
    <div class="fluid-container p-4">
      <div class="saved-header">
        <button class="back-btn" routerLink="/student-dashboard/jobs">
          <i class="bi bi-arrow-left"></i>
          Back
        </button>

        <div class="header-content">
          <h2>Saved jobs</h2>
          <p>Jobs you've bookmarked to revisit ({{ savedCount }})</p>
        </div>
      </div>

      <div class="save-container">
        <div class="card-container">
          <div class="job-card" *ngFor="let job of jobData">
            <div class="job-top">
              <div class="company-info">
                <div class="company-logo">
                  <img *ngIf="job.company_logo" [src]="job.company_logo" alt="company logo" style="width: 100%; height: 100%; border-radius: 16px; object-fit: contain; background: #fff;" />
                  <i *ngIf="!job.company_logo" class="bi bi-briefcase"></i>
                </div>

                <div>
                  <p class="company-name">{{ job.company_name }}</p>
                  <h3>{{ job.job_title }}</h3>
                </div>
              </div>
              <i
                class="bi"
                [ngClass]="
                  job.is_saved
                    ? 'bi-bookmark-fill saved-bookmark'
                    : 'bi-bookmark'
                "
                (click)="toggleSaveJob(job)"
              ></i>
            </div>

            <div class="job-tags">
              <span>{{ job.job_type }}</span>
              <span class="active-tag">{{ job.work_mode }}</span>
              <ng-container *ngIf="job.locations?.length">
                <span *ngFor="let location of job.locations">
                  <i class="bi bi-geo-alt"></i>
                  {{ location }}
                </span>
              </ng-container>
            </div>

            <div class="divider"></div>

            <div class="job-bottom">
              <div *ngIf="job.number_of_openings">
                <i class="bi bi-people"></i>
                {{ job.number_of_openings }} openings
              </div>

              <div *ngIf="job.experience_level">
                <i class="bi bi-clock"></i>
                {{ job.experience_level }}
              </div>
            </div>
            <button class="view-btn" (click)="goToJobsDetailPage(job.job_id)">
              View details
            </button>
          </div>
        </div>
      </div>

      <div class="text-center mt-3 font-name" *ngIf="page < totalPages">
        <button class="btn-add" (click)="loadMore()" [disabled]="isLoading">
          <ng-container *ngIf="isLoading; else showBtnText">
            <span class="spinner-border spinner-border-sm"></span> Loading...
          </ng-container>
          <ng-template #showBtnText>Load More</ng-template>
        </button>
      </div>
    </div>
  </ng-container>
  <ng-template #showMessage>
    <div class="empty-state-wrapper">
      <div class="empty-icon-container">
        <i class="bi bi-bookmark-x"></i>
      </div>
      <h3 class="font-name empty-title">No Saved Jobs</h3>
      <p class="empty-subtitle">You haven't saved any jobs yet. Bookmark jobs you are interested in to view them later.</p>
      <button class="view-btn empty-action-btn" routerLink="/student-dashboard/jobs">Find Jobs to Save</button>
    </div>
  </ng-template>
</ng-template>
